<div class="container" [ngClass]="{'hide': !thank_you && !nudge}">
  <div *ngIf="!thank_you && nudge" class="content-one" (click)="showthankyou()">
    <img class="hand" src="/assets/images/hand_heart.png" alt="heart">
    <span class="title">Add <strong>₹50 more</strong>, to save an extra life this year.</span>
    <span class="button">Add ₹50</span>
  </div>
  <div *ngIf="thank_you" class="content-two">
    <img class="moon" src="/assets/images/moon_heart.png" alt="moon">
    <span class="title-next">Thanks to <strong>YOU</strong>, an extra life will be saved.</span>
  </div>
</div>